import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var teamInSlack = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(root, args, context) {
    var teamId, teamName, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          teamId = args.teamId, teamName = args.teamName;
          url = "".concat(context.url.stargateRoot, "/teamsslack/api/team/").concat(teamId, "?teamName=").concat(encodeURIComponent(teamName));
          return _context.abrupt("return", context.fetch(url).then(function (data) {
            return data.json();
          }).then(function (data) {
            return _objectSpread({
              id: teamId
            }, data);
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function teamInSlack(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export default teamInSlack;